import React from "react";

function normalizeOption(opt) {
  if (opt == null) return null;

  if (typeof opt === "object") {
    return {
      value: opt.value ?? opt.id ?? opt.name ?? "",
      label: opt.label ?? opt.name ?? opt.value ?? "",
    };
  }

  return { value: String(opt), label: String(opt) };
}

export default function TshirtAndPositionStep({
  mode,
  tshirtSize,
  setTshirtSize,
  tshirtSizes,
  position,
  setPosition,
  positions,
  onBack,
  onNext,
  onContinue,
  saving,
  canContinue,
}) {
  if (mode === "tshirt") {
    const sizeOptions = (Array.isArray(tshirtSizes) ? tshirtSizes : [])
      .map(normalizeOption)
      .filter(Boolean);

    return (
      <div className="space-y-4">
        <div className="text-lg font-semibold">What is your t-shirt size?</div>

        <select
          className="w-full border rounded px-3 py-2"
          value={tshirtSize}
          onChange={(e) => setTshirtSize(e.target.value)}
        >
          <option value="">Select size</option>
          {sizeOptions.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>

        <div className="flex justify-between pt-4">
          <button
            type="button"
            className="px-5 py-2 rounded border"
            onClick={onBack}
          >
            Back
          </button>

          <button
            type="button"
            className={`px-5 py-2 rounded text-white ${
              tshirtSize
                ? "bg-blue-700 hover:bg-blue-800"
                : "bg-blue-700/40 cursor-not-allowed"
            }`}
            disabled={!tshirtSize}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </div>
    );
  }

  const posOptions = (Array.isArray(positions) ? positions : [])
    .map(normalizeOption)
    .filter(Boolean);

  return (
    <div className="space-y-4">
      <div className="text-lg font-semibold">Have you changed positions?</div>

      <select
        className="w-full border rounded px-3 py-2"
        value={position}
        onChange={(e) => setPosition(e.target.value)}
      >
        <option value="">Select position</option>
        {posOptions.map((p) => (
          <option key={p.value} value={p.value}>
            {p.label}
          </option>
        ))}
      </select>

      <div className="flex justify-between pt-4">
        <button
          type="button"
          className="px-5 py-2 rounded border"
          onClick={onBack}
          disabled={saving}
        >
          Back
        </button>

        <button
          type="button"
          className={`px-6 py-2 rounded text-white ${
            canContinue
              ? "bg-green-700 hover:bg-green-800"
              : "bg-green-700/40 cursor-not-allowed"
          }`}
          disabled={!canContinue || saving}
          onClick={onContinue}
        >
          {saving ? "Saving..." : "Continue to Payment"}
        </button>
      </div>
    </div>
  );
}
